const isProduction = process.env.NODE_ENV === 'production';
const PORT = process.env.PORT || 5000;
export const API_BASE_URL = process.env.BASE_URL || (process.env.NODE_ENV === 'production'
  ? 'https://vibraint.net'
  : `http://localhost:${PORT}`);